import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface DialogPosition {
  deviceId: string;
  flowRate: string;
  pos: string;
  waterLevel: string;
  velocity: string;
  publish?: string;
  areaName?: string;
  riverName?: string;
}

interface ShowDialogState {
  showDialogWaterLevel: boolean;
  position: DialogPosition;
  isMap: boolean;
  isWaterLevel: boolean;
  isFlowRate: boolean;
  isVelocity: boolean;
}

const initialState: ShowDialogState = {
  showDialogWaterLevel: false,
  position: {
    deviceId: '',
    flowRate: '',
    pos: '',
    waterLevel: '',
    velocity: '',
    publish: '',
    areaName: '',
    riverName: '',
  },
  isMap: true,
  isWaterLevel: false,
  isFlowRate: false,
  isVelocity: false,
};

export const showDialogSlice = createSlice({
  name: 'showDialogSlice',
  initialState,
  reducers: {
    setShowingDialogState: (state, action: PayloadAction<Partial<ShowDialogState>>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setShowingDialogState } = showDialogSlice.actions;

export const showDialogReducer = showDialogSlice.reducer;
